import React, { useEffect, useState } from 'react';
import { useDataLoader, usePerformAction } from 'react-remote-data-hooks';
import AppLayout from '../../core/layouts/AppLayout';
import '../../styles/listing.scss';
import AddRole from './AddRole';
import RoleList from './RoleList';
import Moment from 'react-moment';
import { PaginatedApiResponse, Role } from '../../core/api/models';
import api from '../../api';
import { ContainerLoader } from '../../components/loader';
import RoleDetails from './components/RoleDetails';
import { toastr } from 'react-redux-toastr';
import { ListHeaderSearch, AppPermissions, useHasPermission, ListHeaderDropdown, ListHeader } from '../../core';



import UserLogs from '../../components/logs/user-logs';



const Roles: React.FunctionComponent = () => {
  const [tabName, setTabName] = React.useState<string>('');
  const [tabShow, setTabShow] = React.useState<boolean>(false);
  const handleTabChange = (tabNameValue: string) => {
    setTabName(tabNameValue);
  };
  // const [openAddModal, setOpenAddModal] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState<string>();
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  // const addModelOpen = () => {
  //   setOpenAddModal(true);
  // };
  const headerActions = [];

  const canUpdateRoles = useHasPermission(AppPermissions.UpdateRoles);
  const canAddRoles = useHasPermission(AppPermissions.AddRoles);
  const canViewRoles = useHasPermission(AppPermissions.UpdateRoles);

  const [isDeleteModalOpen, setDeleteModalOpen] = React.useState<boolean>(
    false
  );
  const [addModal, setAddModal] = useState<{
    isOpen?: boolean;
    id?: string;
  }>({});

  const [userLogs, setUserLogs] = React.useState(false);

  const actions = [];
  if (canAddRoles) {
    actions.push({
      text: 'Add Role',
      onClick: () => setAddModal({ isOpen: true }),
    });
  }
  if (canAddRoles) {
    actions.push({
      text: 'User Logs',
      onClick: () => setUserLogs(true),
    });
  }



  if (!!actions?.length) {
    headerActions.push(<ListHeaderDropdown text="Action" actions={actions} />);
  }

  const loadDetails = async (id: string) => {
    const selcRole = data?.data?.find((rl) => rl._id === id);
    if (selcRole) {
      setSelectedRoleId(id);
    }
  };

  const { data, loading, loaded, reload } = useDataLoader<
    PaginatedApiResponse<Role> & { lastUpdatedAt: Date }
  >(
    (searchTerm: string | undefined, currentPage: number) =>
      api.role.getRoles({
        page: currentPage,
        query: searchTerm,
      }),
    [search, page]
  );

  const {
    performAction: updateRole,
    isPerforming: updating,
  } = usePerformAction(
    (id: string, permissions: string[]) =>
      api.role.updateRole(id, { permissions }),
    (updatedRole: Role) => {
      toastr.success('Success', 'Role updated successfully');
      const newData = [...data.data];
      const rl = newData.find((rol) => rol._id === selectedRoleId);
      if (rl) {
        rl.permissions = updatedRole.permissions;
      }
      reload(search, page || 1);
    }
  );

  const {
    performAction: deleteRole,
    isPerforming: deleting,
  } = usePerformAction(
    (id: string) => api.role.deleteRole(id),
    () => {
      toastr.success('Success', 'Role deleted successfully');
      setSelectedRoleId(undefined);
      setDeleteModalOpen(false);
      reload(search, 1);
    }
  );

  useEffect(() => {
    setPage(0);
    reload(search, 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    reload(search, page || 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  useEffect(() => {
    if (
      data?.data.length &&
      (!selectedRoleId || !data?.data.some((r) => r._id === selectedRoleId))
    ) {
      setSelectedRoleId(data?.data.find(() => true)?._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onCreateCompleted = () => {
    reload(search, 1);
    setAddModal({});
  };
  // const companyCreated = () => {
  //   setPage(1);
  //   reload(search, filters, 1, perPage, sort, dateFilters);
  //   setAddModal({});
  // };

  const selectedRole = data?.data?.find((rl) => rl._id === selectedRoleId);

  const renderDeleteConfirm = () => {
    return selectedRoleId && isDeleteModalOpen ? (
      <>
        <div
          className="modal fade show in"
          id="exampleModal"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
            <div className="modal-content rounded-0">
              <div className="modal-body text-center">
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>
                        You are about to delete the role {selectedRole?.name}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={() => setDeleteModalOpen(false)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={() => deleteRole(selectedRole!._id!)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop fade show"></div>
      </>
    ) : (
      <></>
    );
  };

  return (
    <AppLayout>
      <ListHeader actions={headerActions}></ListHeader>
      <div className="list-head">
        <div className="px-lg-4 px-3 py-2 border-bottom">
          <div className="row gutter-10 align-items-center py-1">
            <div className="col">
              <h2 className="m-0">
                Roles
                {data && (
                  <span className="font-xs text-muted font-weight-semibold ml-md-2 mt-md-0 mt-2 d-md-inline-block d-block">
                    {data.count} Total
                    <span className="font-weight-normal ml-1">
                      Updated <Moment fromNow date={data.lastUpdatedAt} />
                    </span>
                  </span>
                )}
              </h2>
            </div>
            {/* {canAddRoles && (
              <div className="col-auto">
                <button
                  className="btn btn-primary font-normal font-weight-semibold py-2 px-3"
                  onClick={() => addModelOpen()}
                >
                  Add New Role
                </button>
              </div>
            )} */}
          </div>
        </div>
      </div>
      <div className="row no-gutters">
        {canViewRoles && (
          <>
            <div className="col-md-4 col-12 border-right">
              <div className="border-bottom d-flex align-items-center">
                <ListHeaderSearch
                  placeholder="Search role"
                  onSearch={setSearch}
                ></ListHeaderSearch>
              </div>

              {(!loaded || loading) && <ContainerLoader></ContainerLoader>}
              {loaded && !loading && (
                <RoleList
                  selectedRoleId={selectedRoleId}
                  setSelectedRoleId={setSelectedRoleId}
                  roles={data?.data}
                  loadDetails={loadDetails}
                  setUserLogs={setUserLogs}
                  userLogs={userLogs}
                ></RoleList>
              )}

            </div>
            {
              userLogs ? <div className="col-md-8 col-12 member-detail bg-white zIndex-1 top-0 left-0 h-100 ">
              <UserLogs filterBy={'Role'}></UserLogs>
            </div> : <>
              {!!selectedRole && (
                <RoleDetails
                  key={selectedRoleId}
                  role={selectedRole}
                  updateRole={updateRole}
                  updating={updating}
                  deleteRole={() => setDeleteModalOpen(true)}
                  deleting={deleting}
                />
              )}</>
            }
          </>
        )}
      </div>
      {/* {openAddModal && (
        <AddRole
          onCreateCompleted={onCreateCompleted}
          onClose={() => setOpenAddModal(false)}
        />
      )}
      {renderDeleteConfirm()} */}
      {addModal.isOpen && (
        <AddRole
          onClose={() => setAddModal({})}
          onCreateCompleted={onCreateCompleted}
        />

      )}
       {renderDeleteConfirm()} 
    </AppLayout>
  );
};

export default Roles;


